// addPhoto 添加图片之后跳转的页面
export const NewEditRouteNames = {
  createCard: 'createCard', // 证件照制作入口
  layoutSelect: 'layoutSelect' // 编辑模板
};

// 非 addPhoto 添加图片之后跳转的页面
export const AddNewRouteNames = {
  edit: 'edit', // 分层 SKU 主编辑
  ...NewEditRouteNames
}; // 后续新增路由

/**
 * 与 Vue Router 各路由 name 一致，供 mwx.ROUTE_NAMES / 路由表共用，避免循环依赖。
 */
export const ROUTE_NAMES = {
  home: 'home', // 首页（path: /）
  selectCard: 'selectCard', // 选择尺寸规格
  customCard: 'customCard', // 自定义规格
  cardDetail: 'cardDetail', // 证件照 SKU 详情
  orderCheck: 'orderCheck', // 购买并校验订单
  saveImage: 'saveImage', // 冲印纸质版 / 保存相关
  orderDetail: 'orderDetail', // 订单详情
  skuDetail: 'skuDetail', // 证件照冲印 SKU 详情
  test: 'test', // 测试页
  addPhoto: 'addPhoto', // 添加照片
  editLifePhoto: 'editLifePhoto', // 生活照编辑
  editPld: 'editPld', // 拍立得编辑
  editNameSticker: 'editNameSticker', // 姓名贴编辑
  selectTemplate: 'selectTemplate', // 拼版模板选择
  selectLifeTemplate: 'selectLifeTemplate', // 人生四格模板选择
  editPb: 'editPb', // 拼版编辑
  editLifePb: 'editLifePb', // 人生四格编辑
  fullscreen: 'fullscreen', // 全屏编辑
  pbDetail: 'pbDetail', // 拼版冲印详情
  finish: 'finish', // 上传成功
  editPaster: 'editPaster', // 异形贴纸编辑
  stickerEdit: 'stickerEdit', // 贴纸编辑
  stickerEditBg: 'stickerEditBg', // 贴纸编辑器内的背景选择页面
  stickerRetouch: 'stickerRetouch', // 贴纸抠图页面
  stickerRetouchFromAdd: 'stickerRetouchFromAdd', // addPhoto 进入的贴纸抠图页面
  stickerLayout: 'stickerLayout', // 贴纸最简排版页面
  selectImage: 'selectImage', // 编辑照片顺序
  editPhotoRoll: 'editPhotoRoll', // 照片卷轴编辑
  photoRollTemplate: 'photoRollTemplate', // 照片卷轴模板选择
  photoRollDetail: 'photoRollDetail', // 照片卷轴模板详情
  retouch: 'retouch', // 手动抠图
  customSize: 'customSize', // 自定义规格（选规格页）
  editCustomSize: 'editCustomSize', // 自定义规格编辑
  changeHole: 'changeHole', // 改孔位
  changeKeyHole: 'changeKeyHole', // 钥匙扣改孔位
  changeSocket: 'changeSocket', // 移动插口
  multipleComponent: 'multipleComponent', // 多部件
  editImage: 'editImage', // 编辑图片（旧）
  editImageNew: 'editImageNew', // 编辑图片（新）
  background: 'background', // 背景页
  editBackground: 'editBackground', // 编辑背景
  editWhiteInk: 'editWhiteInk', // 编辑白墨（旧）
  editWhiteInkNew: 'editWhiteInkNew', // 编辑白墨（新）
  reversePrimerLayer: 'reversePrimerLayer', // 逆向层编辑
  editScopeUv: 'editScopeUv', // 局部uv编辑
  previewColorPaper: 'previewColorPaper', // 色纸预览（旧）
  previewColorPaperNew: 'previewColorPaperNew', // 色纸预览（新）
  previewLaminatedColorPaper: 'previewLaminatedColorPaper', // 覆膜色纸预览
  previewReverseLayer: 'previewReverseLayer', // 逆向层预览
  previewPoster: 'previewPoster', // 生活照海报覆膜预览（仅覆膜）
  editColorPaper: 'editColorPaper', // 色纸编辑
  debug: 'debug', // 调试页（path: /，与 home 同 path 的后注册项）
  demo: 'demo', // demo
  changeOutline: 'changeOutline', // 描边
  ...AddNewRouteNames
};
